import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, Text, View, TouchableOpacity, Platform } from 'react-native';
import { Input, Button } from '../components';
import PetController from '../controllers/petController';
import { PetAddScreen } from '../screens';

class HomePetsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pets: props.pets ? props.pets : []
    }

    this.selectPet = this.selectPet.bind(this);
    this.onAddPet = this.onAddPet.bind(this);
  }

  async componentDidMount() {
    let pets_response = await PetController.getAllPets();

    if(pets_response && pets_response.success && pets_response.pets) {
      let pets = pets_response.pets;
      
      this.setState({
        pets
      });
    }
  }
  
  selectPet(pet) {
    if (this.props.open_pet_details_action) {
      this.props.open_pet_details_action(pet.patient_id)
    }
  }

  async onAddPet() {
    let pets_response = await PetController.getAllPets();

    console.log('getting more pets', pets_response)

    if(pets_response && pets_response.success && pets_response.pets) {
      this.setState({
        pets: pets_response.pets
      })
    }
  }

  render_pets_list = () => {
    let pets_list = this.state.pets || [];
    let pet_rows  = pets_list.map((pet, index) => {
      return <TouchableOpacity key={index}
                               style={styles.pet_list_item}
                               onPress={()=>this.selectPet(pet)}>
        <Text>{ pet.name }</Text>
      </TouchableOpacity>
    }).filter((row) => { return row });

    return <View>
      { pet_rows }
    </View>
  }

  render_add_pet_btn = () => {
    return <View>
      <PetAddScreen onAddPet={this.onAddPet} />
    </View>
  }

  render() {

    return (
      <View style={styles.main_container}>
        <View style={styles.content_container}>
          <Text style={styles.pet_section_title}>MY PETS</Text>
          { this.render_pets_list()   }
          { this.render_add_pet_btn() }
        </View>
      </View>
    );
  }

}

const styles = StyleSheet.create({
  content_container: {

  },
  main_container: {

  },
  pet_section_title: {
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 5,
  },
  pet_list_item: {
    padding: 20,
    borderWidth: 1,
    borderColor: '#e7e7e7',
    backgroundColor: 'white',
    borderRadius: 12,
    marginTop: 2,
    marginBottom: 2
  }
});

export default HomePetsList
